<template>
  <div
    v-if="hasAnyButton"
    class="top-right-controls"
    :class="{ visible: visible }"
    @click.stop
  >
    <EcoModeButton v-if="showEcoButton" :player="player" />
    <HearingImpairedButton :player="player" />
    <InfoButton v-if="showInfoButton" :player="player" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'
import EcoModeButton from '../controls/EcoModeButton.vue'
import HearingImpairedButton from '../controls/HearingImpairedButton.vue'
import InfoButton from '../controls/InfoButton.vue'

const props = defineProps<{
  visible?: boolean
  player: UseVideoPlayerReturn
  showEcoMode?: boolean
  showInfoButton?: boolean
}>()

// The preset may hide the eco button; the stream hides it when no quality is above 720p, eco
// mode then holding nothing back.
const showEcoButton = computed(() => !!props.showEcoMode && props.player.hasEcoHeadroom.value)

const hasAnyButton = computed(
  () => !!(showEcoButton.value || props.showInfoButton || props.player.hearingImpairedTrack.value),
)
</script>

<style scoped lang="scss">
/* Styles in main.scss > _top-right-controls.scss */
</style>
